var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBus = function SvgBus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 7.084A2.917 2.917 0 0 0 2.083 10v18.334c0 .69.56 1.25 1.25 1.25H5.59a4.583 4.583 0 0 0 8.82 0h11.18a4.583 4.583 0 0 0 8.82 0h2.257c.69 0 1.25-.56 1.25-1.25V20c0-3.314-.938-6.545-2.674-8.976-1.74-2.436-4.206-3.94-6.91-3.94H5m0 2.5h5.417v5.833H4.583V10A.417.417 0 0 1 5 9.584m13.75 0h-5.833v5.833h5.833zm2.5 5.833V9.583h4.406l1.25 5.833zm-1.279 2.5h7.471l.502 2.345a1.25 1.25 0 0 0 1.223.988h6.25v5.834H34.41a4.584 4.584 0 0 0-8.82 0H14.41a4.584 4.584 0 0 0-8.82 0H4.583v-9.167h15.388m13.238-5.44c1.185 1.66 1.956 3.873 2.156 6.273h-5.188l-1.964-9.166h.12c1.717 0 3.49.953 4.876 2.893M12.083 28.326v.015a2.083 2.083 0 1 1 0-.015m20 0v.015a2.083 2.083 0 1 1 0-.015",
    clipRule: "evenodd"
  })));
};
export default SvgBus;